import { Button } from '@postscript/components';
import { useQueryClient } from '@tanstack/react-query';
import PageHeader from 'components/layout/PageHeader';
import { RESPONSES_QUERY_KEYS } from 'components/responses/constants';
import { useSessionDashboard } from '../hooks/useDashboard';
import SessionsList from './SessionsList';

const SessionDashboard = (): JSX.Element => {
  const queryClient = useQueryClient();
  const refreshSessionData = () => {
    queryClient.invalidateQueries({
      queryKey: [RESPONSES_QUERY_KEYS.SESSION_DASHBOARD],
    });
  };

  const searchParams = new URLSearchParams(window.location.search);
  const timeFilter = searchParams.get('datetime') ?? '';
  const { data, isLoading } = useSessionDashboard(timeFilter);

  return (
    <div>
      <PageHeader
        pageTitle="Agent Sessions"
        description="View agent session history"
        actions={<Button onClick={() => refreshSessionData()}>Refresh</Button>}
      />
      {data && (
        <SessionsList
          data={data}
          isLoading={isLoading}
          timeFilter={timeFilter}
        />
      )}
    </div>
  );
};

export default SessionDashboard;
